import React from 'react'

import VerifiedOrErrorMessages from '../../VerifiedOrErrorMessages'
import {
  getHasAnyChildren,
  getIsNotInPendingStatus,
} from '../../Verifiers'

export default props => (
  <VerifiedOrErrorMessages
    verifiers={[
      {
        verifierFunction: getHasAnyChildren,
      },
      {
        verifierFunction: getIsNotInPendingStatus,
      },
    ]}
    {...props}
  />
)
